window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['cartAddLink']) return;

  function cartAddLink(data = {}) {
    return {
      ...data,

      isLoadingCartAddLink: false,

      onClick() {
        if (this.isLoadingCartAddLink) return;

        dispatchEvent(new CustomEvent('cartchangestart', { detail: { showModal: this.showModal } }));

        this.isLoadingCartAddLink = true;

        var url = new URL(this.$el.href);

        var id = url.searchParams.get('id') || null;

        var quantity = url.searchParams.get('quantity') || null;

        var fetchUrl = url.pathname;

        var formData = new FormData();

        formData.set('id', id);
        formData.set('quantity', quantity);
        formData.set('sections', this.$store.cart.sectionIds);

        url.searchParams.forEach((value, key) => {
          if (key.match(/^properties\[(.+)\]$/)) {
            formData.set(key, value);
          }
        });

        var fetchOptions = {
          method: 'post',
          body: formData,
          headers: {
            'Accept': 'application/javascript',
            'X-Requested-With': 'XMLHttpRequest'
          }
        };

        fetch(fetchUrl, fetchOptions)
          .then((res) => {
            if (!res.ok) {
              return res.text().then((err) => { throw new Error(err) });
            }

            return res.json();
          })
          .then((res) => {
            dispatchEvent(new CustomEvent('cartchangesuccess', { detail: { res } }));
          })
          .catch((err) => {
            dispatchEvent(new CustomEvent('cartchangeerror', { detail: { err } }));
          })
          .finally(() => {
            dispatchEvent(new CustomEvent('cartchangeend'));
            this.isLoadingCartAddLink = false;
          });
      }
    };
  };

  Alpine.data('cartAddLink', cartAddLink);

  window.global.registeredAlpineComponents['cartAddLink'] = true;
});
